import { TextField, Button,Box, Select } from "@okta/odyssey-react-mui";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { CalendarIcon } from "@okta/odyssey-react-mui/icons";
import dayjs from "dayjs";

const EditableDateField = ({label, startValue, endValue, onSave}) => {
    const {t} = useTranslation();
    const [timezone, setTimezone] = useState('UTC');
    const [editedStartValue, setEditedStartValue] = useState(startValue);
    const [editedEndValue, setEditedEndValue] = useState(startValue);

    const[isEditMode,setIsEditMode] = useState(false)
    if(isEditMode){
        return (
            <>
                <Select
                    name="timezone"
                    label={t('createForm-timezone',{ns:'events'})}
                    options={[
                        { text: t('timezone-utc', { ns: 'events' }), value: 'UTC' },
                        { text: t('timezone-tokyo', { ns: 'events' }), value: 'Asia/Tokyo' },
                        { text: t('timezone-singapore', { ns: 'events' }), value: 'Asia/Singapore' },
                        { text: t('timezone-sydney', { ns: 'events' }), value: 'Australia/Sydney' },
                        { text: t('timezone-bengaluru', { ns: 'events' }), value: 'Asia/Kolkata' },
                        { text: t('timezone-paris', { ns: 'events' }), value: 'Europe/Paris' },
                        { text: t('timezone-stockholm', { ns: 'events' }), value: 'Europe/Stockholm' },
                        { text: t('timezone-london', { ns: 'events' }), value: 'Europe/London' },
                        { text: t('timezone-newyork', { ns: 'events' }), value: 'America/New_York' },
                        { text: t('timezone-toronto', { ns: 'events' }), value: 'America/Toronto' },
                        { text: t('timezone-sanfrancisco', { ns: 'events' }), value: 'America/Los_Angeles' },
                    ]}
                    defaultValue="UTC"
                    value={timezone}
                    onChange={e => setTimezone(e.target.value)}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker name="start" label='Event Start' value={dayjs(startValue)} onChange={(e)=>setEditedStartValue(e)} timezone={timezone}/>
                    <DateTimePicker name="end" label='Event End' value={dayjs(endValue)} onChange={(e)=>setEditedEndValue(e)} timezone={timezone}/>
                </LocalizationProvider>
                <Box sx={{maxWidth: '55ch'}}>
                    <Box sx={{display:'flex', justifyContent:'end'}}>
                        <Button variant='floating' label={t('cancel',{ns:'events'})} onClick={() => setIsEditMode(false)}/>
                        <Button label={t('save',{ns:'events'})} onClick={()=>{onSave(dayjs(editedStartValue).tz(timezone).utc().format(),dayjs(editedEndValue).tz(timezone).utc().format()); setIsEditMode(false)}}/>
                    </Box>
                </Box>
            </>
        )
    } else {
        return (
            <TextField label={label} isReadOnly value={dayjs(startValue).utc().format("DD MMM YYYY HH:mm") + '-' + dayjs(endValue).utc().format("DD MMM YYYY HH:mm") + ' UTC'} startAdornment={<CalendarIcon/>} endAdornment={<Button label={t('edit',{ns:'events'})} onClick={()=>{setEditedStartValue(startValue);setEditedEndValue(endValue);setIsEditMode(true)}}/>}/>
        )
    }
}
export default EditableDateField